import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckCircle from '@mui/icons-material/CheckCircle';
import { useTranslation } from 'react-i18next';
import { Info } from '@mui/icons-material';

interface Props {
  fileName?: string;
  fileUploaded: boolean;
}

const FileUploadStatus: React.FC<Props> = ({ fileName, fileUploaded }) => {
  const { t } = useTranslation('interface');

  return (
    <Box
      display='flex'
      alignItems='center'
      gap={1}
      p={2}
      borderRadius={2}
      bgcolor={fileUploaded ? 'success.light' : 'info.light'}
      color={fileUploaded ? 'success.main' : 'info.main'}
    >
      {fileUploaded ? <CheckCircle fontSize='small' /> : <Info fontSize='small' />}
      <Typography variant='body2' sx={{ fontSize: '10px' }}>
        {fileUploaded
          ? `${t('simulation.experimental_settings.file_status.file_uploaded')}: ${fileName}`
          : t('simulation.experimental_settings.file_status.no_file')}
      </Typography>
    </Box>
  );
};

export default FileUploadStatus;
